import { InputAdornment, IconButton } from '@mui/material';
import React, {useEffect} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import {CustomTextField} from "../CustomTextField";
import {debounce} from "lodash";
import {DEBOUNCE_DELAY} from "../../Apis/functions";
import { CloseIcon } from '../buttons/IconButtons';

/**
 * @param {string} id - Unique identifier for the input field.
 * @param {string} label - Translation key used as the input label.
 * @param {string} value - Controlled input value.
 * @param {function} setValue - Setter function to update input value.
 * @param {boolean} [disabled=false] - Disables the input when true.
 * @param {number} [length=180] - Maximum number of characters allowed.
 * @param {boolean} [required=false] - Marks field as required.
 * @param {function} onChange - Input change handler.
 * @param {function} [onSearchIcon] - Callback triggered when clicking the search icon.
 * @param {function} [onReset] - Callback triggered when clearing the input.
 * @param {function} [searchFunction] - Function executed with debounce when value changes.
 * @param {function} [setSendSimpleSearch] - Enables external flag when input is focused.
 * @param {boolean} [emptyFields=false] - Validation state for empty field error.
 * @param {boolean} [isValid=true] - Indicates if current value passes validation.
 * @param {string} [isValidText] - Message key shown when validation fails.
 * @param {boolean} [showCounter=false] - Shows character counter under input.
 */

const CustomSearch = ({
    id,
    label,
    value,
    setValue,
    disabled=false,
    length=180,
    required=false,
    onChange,
    onSearchIcon,
    onReset,
    searchFunction=() =>{},
    setSendSimpleSearch,
    emptyFields=false,
    isValid=true,
    isValidText,
    showCounter=false
}) => {

    useEffect(() => {
        const debouncedFilter = debounce(() => {
            searchFunction(value);
        }, DEBOUNCE_DELAY);

        debouncedFilter();
        return () => debouncedFilter.cancel();
    }, [value]);

    return (
        <CustomTextField id={id}
                         trans={label}
                         type={"text"}
                         onChange={onChange}
                         value={value}
                         disabled={disabled}
                         length={length}
                         required={required}
                         showCounter={showCounter}
                         onFocus={() => setSendSimpleSearch && setSendSimpleSearch(true)}
                         isValid={isValid}
                         isValidText={isValidText}
                         emptyFields={emptyFields}
                         InputProps={{
                             endAdornment: (
                                 <>
                                     <InputAdornment position='end'>
                                         <SearchIcon onClick={onSearchIcon} />
                                     </InputAdornment>
                                     {value && (
                                         <InputAdornment position='end'>
                                             <IconButton onClick={() => {
                                                 setValue("");
                                                 onReset();
                                                }}>
                                                 <CloseIcon  className={'w-16px'}/>
                                             </IconButton>
                                         </InputAdornment>
                                     )}
                                 </>
                             ),
                         }}
        />
    );
};

export default CustomSearch;
